module.exports = __webpack_public_path__ + "static/media/file-plus.44e4659b.svg";